const exported = {
    AndroidcookieVersion:'7.0.14',

    // 安卓要大于这个版本0x27000e33才支持cookie，即大于等于0x27000e34
    AndroidHexCookieVersion: 0x27000e34,

    // iOS大于等于7.0.17版本，才认为cookie登录态可用
    iosCookieVersion:'7.0.17'
};

export default exported;

export const {
    AndroidcookieVersion,
    AndroidHexCookieVersion,
    iosCookieVersion
} = exported;
